export interface Manga {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  tags: string[];
  author: string;
  cover: string;
  status: "连载中" | "已完结";
  rating: number;
  favorites: number;
  chapters: number;
  episode: string;
  updateTime: string;
  summary: string;
  intro: string[];
}

export const mangaList: Manga[] = [
  {
    slug: "mianbao-dian-maomi-dianzhang",
    title: "面包店的猫咪店长",
    category: "yuzhi",
    categoryName: "治愈番",
    tags: ["治愈", "温馨日常", "慢生活"],
    author: "阿团",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20warm%20illustration%20of%20a%20cute%20calico%20cat%20wearing%20a%20little%20apron%20behind%20a%20cozy%20bread%20counter%20with%20croissants%2C%20steam%20and%20golden%20light%2C%20pastel%20peach%20and%20cream%20palette%2C%20healing%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-bread-cat&orientation=portrait",
    status: "连载中",
    rating: 9.6,
    favorites: 128400,
    chapters: 128,
    episode: "第128话 · 今日特供",
    updateTime: "今天 10:30",
    summary:
      "在街角开着一家只属于猫咪的面包店。店长是只慵懒的三花猫，每天只做限量的蜂蜜吐司，来买面包的客人总会被它温柔地治愈。",
    intro: [
      "喵喵街的尽头有家小小的面包店，店名就叫『面包店的猫咪店长』。",
      "店长是一只总在打瞌睡的三花猫，但它烤出来的蜂蜜吐司却香得能叫醒整条街。每天清晨，排队的客人都被它慢悠悠、暖融融的节奏治愈。",
      "这里有追着烤箱跑的小狗学徒，有每天来买奶油包的失意上班族，也有放学后赖在窗边不肯走的孩子们。没有惊天动地的剧情，只有一炉一炉烤出来的温柔日常。",
      "如果你也在找一处让心安静下来的角落，不妨推开门，坐下喝杯热茶，听店长喵一声：欢迎光临。",
    ],
  },
  {
    slug: "ruan-ruan-de-mao-erduo",
    title: "软软的猫耳朵",
    category: "ruanmeng",
    categoryName: "软萌画风",
    tags: ["软萌", "萌系", "可爱"],
    author: "奶昔酱",
    cover:
      "https://readdy.ai/api/search-image?query=cute%20kawaii%20illustration%20of%20a%20round%20girl%20character%20with%20fluffy%20cat%20ears%20and%20big%20sparkling%20eyes%20blushing%2C%20soft%20mint%20and%20cream%20pastel%20background%20with%20stars%20and%20clouds%2C%20korean%20kawaii%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-cat-ear&orientation=portrait",
    status: "连载中",
    rating: 9.4,
    favorites: 98600,
    chapters: 86,
    episode: "第86话 · 耳尖微微发烫",
    updateTime: "昨天 20:15",
    summary:
      "人类小桃捡到一只会变成猫耳少女的神秘生物。从那天起，她的日常每天都毛茸茸、软乎乎的。高甜软萌小日常，一集就上瘾。",
    intro: [
      "某天回家，小桃发现窗台上蹲着一只耳朵会打卷的猫。想抱它，它却「啪」地变成了一只猫耳少女。",
      "「你…你是什么？」小桃瞪大了眼睛。「我是会寄住在你家猫耳朵的精灵啦！」猫耳少女理直气壮。",
      "从此以后，小桃的日常里多了梳毛、煮小鱼干、还有每天被猫耳朵蹭得心痒痒的小插曲。",
      "这是一部光看着就会被甜到化的软萌小日常，心情不好的时候点开它，世界都会变得毛茸茸的。",
    ],
  },
  {
    slug: "jintian-ye-yuanqi-manman",
    title: "今天也元气满满",
    category: "wenxin",
    categoryName: "温馨向轻喜剧",
    tags: ["轻喜剧", "温馨", "治愈"],
    author: "橘子汽水",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20cheerful%20illustration%20of%20a%20happy%20little%20cat%20stretching%20arms%20toward%20a%20rising%20sun%20with%20a%20giant%20smile%2C%20orange%20and%20cream%20sunrise%20tones%2C%20confetti%20and%20sparkles%2C%20feelgood%20light%20comedy%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-energy&orientation=portrait",
    status: "已完结",
    rating: 9.2,
    favorites: 81200,
    chapters: 142,
    episode: "第142话 · 完 谢谢你的陪伴",
    updateTime: "3天前 09:00",
    summary:
      "住在同一栋公寓楼里的五户人家，用一碗热汤、一句早安、一件傻事，把普通日子过成了温暖的轻喜剧。看完心情会变好。",
    intro: [
      "阳光公寓的第五层，住着五个性格迥异的家伙：爱赖床的上班族、总是迷路的外卖员、嗓门很大的晨练大爷、养了三只猫的插画师，还有永远元气满满的楼长。",
      "他们的日常没什么大事，却处处是笑点：楼长组织的『社区运动会』永远一团乱、插画师的猫总把整层楼的盆栽当枕头……",
      "可就是这些鸡毛蒜皮的小事，让每个下班回家的晚上都变得暖乎乎的。",
      "这是一部看完会想给邻居送一碗热汤的温馨向轻喜剧，轻松、好笑，又足够温暖。",
    ],
  },
  {
    slug: "naixiong-san-xiongmei",
    title: "奶凶三兄妹",
    category: "gaoxiao",
    categoryName: "搞笑萌漫",
    tags: ["搞笑", "萌系", "兄妹日常"],
    author: "河马不睡觉",
    cover:
      "https://readdy.ai/api/search-image?query=funny%20illustration%20of%20three%20chubby%20baby%20kittens%20in%20pyjamas%20sticking%20out%20tongues%20and%20puffing%20cheeks%20to%20look%20fierce%20but%20adorable%2C%20soft%20pink%20and%20cream%20tones%2C%20confetti%2C%20comic%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-siblings&orientation=portrait",
    status: "连载中",
    rating: 9.0,
    favorites: 76400,
    chapters: 210,
    episode: "第210话 · 大哥的名场面",
    updateTime: "今天 08:40",
    summary:
      "表面凶巴巴、实际上软到不行的三兄妹。老二是个白切黑，老三整天想着离家出走又被一碗面哄回来。全程高能搞笑，笑到缺氧。",
    intro: [
      "虎头、奶糖、肉球——名字一个比一个凶，可爱却一个比一个超标。这就是传闻中的『奶凶三兄妹』。",
      "大哥虎头自诩全家最凶，结果被一颗棉花糖吓到躲进被窝；二哥奶糖表面乖巧，实则腹黑得能把大哥绕晕；小妹肉球喊着要离家出走，闻到红烧肉香气立刻叛变。",
      "三兄妹的日常就是一场没有硝烟（但全是笑点）的战争，吵吵闹闹、毛茸茸，越看越上头。",
      "适合压力大、需要笑一笑的你。请备好水和纸巾，因为真的会笑到流泪。",
    ],
  },
  {
    slug: "wuhou-de-chuangbian-mao",
    title: "午后的窗边猫",
    category: "ruanmeng",
    categoryName: "软萌画风",
    tags: ["软萌", "治愈", "唯美"],
    author: "云朵苏打",
    cover:
      "https://readdy.ai/api/search-image?query=serene%20beautiful%20illustration%20of%20a%20white%20fluffy%20cat%20sleeping%20on%20a%20sunny%20window%20sill%20with%20drifting%20curtains%20and%20falling%20petals%2C%20soft%20golden%20and%20cream%20pastel%20tones%2C%20dreamy%20kawaii%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-window-cat&orientation=portrait",
    status: "已完结",
    rating: 9.5,
    favorites: 145300,
    chapters: 64,
    episode: "第64话 · 未完待续的晴天",
    updateTime: "1周前 15:20",
    summary:
      "没有旁白、没有对白，只有一只猫、一扇窗、和缓缓流淌的四季。唯美的软萌画风配上温柔色调，是治愈系里的视觉天花板。",
    intro: [
      "这是一部几乎没有台词的漫画。主角是一只总爱趴在窗边的白色猫咪，窗外是它看过的一年四季。",
      "春天有樱花飘进窗台，夏天有雷雨和旧风扇，秋天有落叶铺满街角，冬天有第一场雪的安静。猫咪有时打盹，有时望向远方，偶尔回头看你一眼。",
      "整部作品像是把『岁月静好』画成了画，每一格都可以当壁纸。",
      "心情浮躁的时候翻开它，就像午后真的有一束阳光照在了窗边，世界一下子安静下来。",
    ],
  },
  {
    slug: "tuanzhang-de-yibai-zhong-richang",
    title: "团长的一百种日常",
    category: "gaoxiao",
    categoryName: "搞笑萌漫",
    tags: ["搞笑", "单元剧", "脑洞"],
    author: "肥宅快乐水",
    cover:
      "https://readdy.ai/api/search-image?query=absurd%20funny%20illustration%20of%20a%20cute%20cat%20wearing%20a%20tiny%20knight%20helmet%20holding%20a%20fork%20as%20a%20sword%20atop%20a%20pile%20of%20pillows%2C%20goofy%20expressions%2C%20bright%20soft%20yellow%20and%20cream%20palette%2C%20comic%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-captain&orientation=portrait",
    status: "连载中",
    rating: 9.1,
    favorites: 69000,
    chapters: 175,
    episode: "第175话 · 团长的旗子",
    updateTime: "2天前 19:00",
    summary:
      "一只自称『团长』的猫，每天都用一本正经的沙雕操作统治整个家。一百个脑洞小剧场，笑点密集到根本停不下来。",
    intro: [
      "家里的猫自称『团长』，认为这个家是它的领地，铲屎官只是它的『首席侍从』。",
      "于是团长每天都有新的作战计划：把遥控器藏进猫窝是『战略转移』，扒拉盆栽是『国土勘测』，半夜踩脸是『夜间巡逻』……",
      "每一话都是一出独立的小剧场，脑洞大到离谱，却总在结尾被一盘小鱼干当场拆穿。",
      "养猫人和没养猫的人都能笑出声——毕竟，猫到底在想什么，永远是个谜。",
    ],
  },
  {
    slug: "yuanqi-shaonv-de-xingqitian",
    title: "元气少女的星期天",
    category: "wenxin",
    categoryName: "温馨向轻喜剧",
    tags: ["温馨", "轻喜剧", "青春"],
    author: "柠檬汽水",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20youthful%20illustration%20of%20a%20smiling%20girl%20with%20soda%20can%20and%20scattered%20snacks%20on%20a%20picnic%20blanket%20in%20a%20sunny%20park%2C%20orange%20peach%20and%20cream%20tones%2C%20feelgood%20light%20comedy%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-sunday&orientation=portrait",
    status: "连载中",
    rating: 8.9,
    favorites: 58700,
    chapters: 96,
    episode: "第96话 · 一起野餐吧",
    updateTime: "昨天 12:10",
    summary:
      "元气少女小满每周日都会做一件小计划：做一顿早餐、逛一次公园、和邻居聊个天。她把平凡周日过成了治愈人心的轻喜剧。",
    intro: [
      "对小满来说，星期天是一周里最珍贵的礼物。她会在前一天列好『周日计划表』，然后一件件把它们实现。",
      "烤一炉有点焦的松饼、给路边的猫买根火腿肠、和楼下的奶奶学做腌菜、在公园长椅上把漫画读完……",
      "她的计划总会被意外打乱，但每一次『意外』都让她笑得更开心。",
      "这部漫画用小小的善意和明亮的笑声，告诉你：治愈不必等远方，平凡的星期天也可以很温暖。",
    ],
  },
  {
    slug: "linju-jia-de-maoqiu",
    title: "邻居家的毛球",
    category: "yuzhi",
    categoryName: "治愈番",
    tags: ["治愈", "邻居", "萌宠"],
    author: "汤圆铺子",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20illustration%20of%20a%20fluffy%20round%20cat%20peeking%20over%20a%20balcony%20railing%20at%20a%20smiling%20neighbor%20with%20a%20cup%20of%20tea%2C%20warm%20evening%20apartment%20scene%2C%20pastel%20peach%20and%20cream%20palette%2C%20healing%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-neighbor&orientation=portrait",
    status: "连载中",
    rating: 9.3,
    favorites: 102600,
    chapters: 110,
    episode: "第110话 · 阳台上的约定",
    updateTime: "今天 07:50",
    summary:
      "独居的上班族偶然发现，隔壁阳台总趴着一只圆滚滚的猫。一人一猫隔着阳台的日常，是城市里最温柔的相遇。",
    intro: [
      "阿岚一个人住在城市的高楼里，生活两点一线，说不上坏，也说不上好。直到某天，他发现隔壁阳台多了一只圆滚滚的猫。",
      "那只猫每天固定时间趴在阳台边，眯着眼睛晒太阳。阿岚开始忍不住给它准备小鱼干、陪它「隔空对话」，也第一次和隔壁那位同样话不多的邻居打起了招呼。",
      "原来所谓的『治愈』，有时候只是一只猫愿意在阳台边等你。",
      "这是一部写给都市人的温柔漫画，关于孤独、陪伴，以及那些悄悄发生的美好。",
    ],
  },
  {
    slug: "haiwai-shushu-de-tianwei",
    title: "海味叔叔的甜味",
    category: "wenxin",
    categoryName: "温馨向轻喜剧",
    tags: ["美食", "温馨", "单元剧"],
    author: "海边的小铺",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20illustration%20of%20a%20kind%20older%20cat%20chef%20serving%20a%20bowl%20of%20steaming%20soup%20to%20happy%20customers%20at%20a%20cozy%20seaside%20food%20stall%2C%20soft%20mint%20and%20cream%20tones%2C%20light%20comedy%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-seafood&orientation=portrait",
    status: "已完结",
    rating: 9.0,
    favorites: 52800,
    chapters: 88,
    episode: "第88话 · 欢迎下次光临",
    updateTime: "5天前 18:00",
    summary:
      "海边的深夜小摊，叔叔用一碗碗热汤治愈了形形色色的客人。美食 + 人情 + 一点小搞笑的温馨向轻喜剧，下饭必备。",
    intro: [
      "每当夜风把海水的咸味吹进巷子，街角的『叔叔小摊』就会亮起灯。摊主叔叔话不多，但每道菜都做得让人眼眶发热。",
      "失恋的女孩来喝甜汤，加班族来吃宵夜，吵架的邻居来分一锅鱼汤——叔叔一边听故事，一边往汤里偷偷多放两颗糖。",
      "偶尔也会有乌龙：把盐当成糖、把客人点的菜做成三道，闹出不少笑话，却总能在结尾变得暖洋洋。",
      "这是一部下饭的温馨向轻喜剧，看完你也想去海边，找一位会往汤里加糖的叔叔。",
    ],
  },
  {
    slug: "xingqiqi-de-dingdan",
    title: "星期七的订单",
    category: "ruanmeng",
    categoryName: "软萌画风",
    tags: ["软萌", "奇幻", "治愈"],
    author: "月见团子",
    cover:
      "https://readdy.ai/api/search-image?query=magical%20cute%20illustration%20of%20a%20little%20delivery%20cat%20carrying%20a%20gift%20box%20with%20sparkling%20wings%20over%20a%20dreamy%20moonlit%20town%2C%20soft%20pastel%20lavender%20free%20cream%20and%20gold%20tones%2C%20kawaii%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-order&orientation=portrait",
    status: "连载中",
    rating: 9.1,
    favorites: 71500,
    chapters: 54,
    episode: "第54话 · 凌晨的包裹",
    updateTime: "昨天 22:40",
    summary:
      "只在星期七营业的神秘小店，接单后由一只猫耳店员骑着星星车派送。软萌画风包裹着温柔的小故事，每一单都是治愈。",
    intro: [
      "这个世界的星期七，是日历上不存在的一天。只有传说中那家『星期七小店』会在这天开门。",
      "店长是一只戴着小铃铛的猫耳店员，它接下人们的委托，用星星做的小车，把『幸福』送到需要的人手中。",
      "给失眠的姐姐送一颗会唱摇篮曲的星星、给想念外婆的孩子送一罐会说话的薄荷糖……",
      "每一单订单，都是一个温柔到让人想哭的小故事。软萌画风 + 奇幻治愈，是睡前最合适的选择。",
    ],
  },
  {
    slug: "da-laoshi-he-tade-mao",
    title: "大老师和他的猫",
    category: "yuzhi",
    categoryName: "治愈番",
    tags: ["治愈", "师生", "慢生活"],
    author: "慢炖的粥",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20illustration%20of%20a%20warm%20old%20teacher%20cat%20with%20glasses%20reading%20a%20book%20while%20a%20small%20cat%20rests%20on%20his%20shoulder%2C%20cozy%20library%20with%20warm%20lamplight%2C%20soft%20peach%20and%20cream%20palette%2C%20healing%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-teacher&orientation=portrait",
    status: "连载中",
    rating: 9.4,
    favorites: 91200,
    chapters: 99,
    episode: "第99话 · 窗前的一页",
    updateTime: "4天前 20:00",
    summary:
      "退休的老教师回乡下养老，身边只有一只捡来的猫作伴。师生、邻里、猫，静静流淌的岁月里满是温柔的牵挂。",
    intro: [
      "退休那年，大老师回到阔别多年的小村庄。行李很少，却带着一箱子旧书，和一只在路边捡到的小猫。",
      "他每天在院子里晒太阳、给孩子们讲过去的故事、替邮差照看路过的小狗。那只猫总是趴在他脚边，偶尔用尾巴拍拍他。",
      "村里人都说，大老师就像村口那棵老树，安静、可靠，让人心安。",
      "这是一部慢慢读才懂得温柔的治愈番。它告诉我们，岁月会老去，但善意和牵挂不会。",
    ],
  },
  {
    slug: "a-xiong-di-de-nichao",
    title: "阿雄弟的逆潮",
    category: "gaoxiao",
    categoryName: "搞笑萌漫",
    tags: ["搞笑", "反差萌", "兄弟"],
    author: "旺财社",
    cover:
      "https://readdy.ai/api/search-image?query=funny%20illustration%20of%20a%20muscular%20dog%20wearing%20a%20tiny%20bow%20tie%20trying%20to%20look%20tough%20while%20a%20tiny%20chick%20sits%20on%20his%20head%2C%20goofy%20expression%2C%20bright%20soft%20pink%20and%20cream%20tones%2C%20comic%20storybook%20vector%20art%2C%20portrait%20composition&width=800&height=1000&seq=manga-wangcai&orientation=portrait",
    status: "已完结",
    rating: 8.8,
    favorites: 43900,
    chapters: 72,
    episode: "第72话 · 完 逆潮结束",
    updateTime: "2周前 16:00",
    summary:
      "外表凶悍、内心柔软的狗哥，每天都在和一只小得可怜的小鸡斗智斗勇。反差萌 + 爆笑日常，让人笑到拍桌。",
    intro: [
      "阿雄是一只看似凶悍的狼犬，走路带风、吼声能震碎玻璃。可实际上，它连踩到蚂蚁都会心疼半天。",
      "直到一只小鸡「啪叽」掉到它头上，从此它的『威猛人生』彻底翻车——被小鸡追着跑、被小鸡抢狗粮、被小鸡当床垫。",
      "一个想装凶、一个真不怕，两个家伙的逆潮日常，笑点密集到停不下来。",
      "这部搞笑萌漫用满屏的反差萌告诉你：最硬的外壳里，可能住着最软的心。",
    ],
  },
];

export const mangaMap: Record<string, Manga> = mangaList.reduce(
  (acc, m) => {
    acc[m.slug] = m;
    return acc;
  },
  {} as Record<string, Manga>
);

export const formatFavorites = (n: number): string => {
  if (n >= 100000) return `${(n / 10000).toFixed(1)}万`;
  if (n >= 10000) return `${(n / 10000).toFixed(0)}万`;
  return String(n);
};